import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.css';
import './static/style.css';

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
